/* unplugin-vue-components disabled */import script from "./StudyMaterialView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudyMaterialView.vue?vue&type=script&setup=true&lang=ts"

import "./StudyMaterialView.vue?vue&type=style&index=0&id=490d755b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490d755b"]])

export default __exports__